import React, { Component } from 'react';
import api, { API_ENDPOINTS } from '../api/Api';
import { message } from 'antd';

import { getCompare, removefromCompare } from '../utils/byoscart';

import Loader from './utils/Loadersmall';

class Compare extends Component {

    constructor(props) {
        super(props);
        this.state = {
            compareList:[],
            serviceCheck:false,
        }   
    }


    componentDidMount() {
        window.scrollTo(0, 0);
        this.loadCompareList();
    }

    async loadCompareList() {

        let CompareValue=getCompare();
        if(CompareValue!=''){
            const params = new URLSearchParams();
            params.append('compare_codes', CompareValue);
            try {
            const response = await api.post(API_ENDPOINTS.legacy.compare, params);
            let resVal=response.data;
                if(resVal.status==='success'){
                    this.setState({compareList:Array.isArray(resVal.data) ? resVal.data : [], serviceCheck:true});
                }else{
                    this.setState({compareList:[], serviceCheck:true});
                }
            } catch (error) {
            this.setState({compareList:[], serviceCheck:true});
            console.error(error);
            }
        }else{
            this.setState({compareList:[], serviceCheck:true});
        }
    }

    localremovefromCompare(varCode){
        /* update store values */
        removefromCompare(varCode);
        this.loadCompareList();
        message.success({
            content: 'Succeessfully removed from compare',
            className: 'notificationBox',
        });
    }


    render() {

        if(this.state.serviceCheck===false)
        return (<Loader/>);

        const compareGroups = Array.isArray(this.state.compareList) ? this.state.compareList : [];

        return (

            <div className="ps-about ps-compare-page">
                <div className="ps-about__content">
                    <section className="ps-about__project">
                        <div className="container">
                            <div className="ps-compare__hero">
                                <div className="ps-compare__eyebrow">Compare products</div>
                                <h2 className="ps-compare__title">Side-by-side product comparison</h2>
                                <p className="ps-compare__subtitle">Review product details, features, and images in a clean comparison view before you decide.</p>
                            </div>

                            {(compareGroups.length < 1)?
                                <div className="ps-compare__empty">
                                    <img src="/assets/img/compare-empty.svg" className="noCompareImage" alt="No compare items"/>
                                    <h4>There are no products in your compare list yet.</h4>
                                    <p>Add a few products to see the differences side by side.</p>
                                </div>
                            :
                                <div className="ps-compare__list">
                                    {compareGroups.map((compareItem, compareIndex)=>{
                                        const compareRows = Array.isArray(compareItem[1]) ? compareItem[1] : [];
                                        const productOverview = compareRows.find((item)=>item[0] === 'ProductOverview');
                                        const productCards = productOverview && Array.isArray(productOverview[1]) ? productOverview[1] : [];

                                        return(
                                            <div className="ps-compare__section" key={`${compareItem[0]}-${compareIndex}`}>
                                                <div className="ps-compare__section-header">
                                                    <h3>{compareItem[0]}</h3>
                                                    <span>{productCards.length} products</span>
                                                </div>

                                                <div className="ps-compare__products">
                                                    <div className="ps-compare__label-cell">Product</div>
                                                    {productCards.map((product, productIndex)=>{
                                                        return(
                                                            <div className="ps-compare__product-cell" key={`${product.product_variant_id || productIndex}-${productIndex}`}>
                                                                <button className="compareButton ps-compare__remove" onClick={()=>this.localremovefromCompare(product.product_variant_id)}>Remove</button>
                                                                <div className="ps-compare__imageWrap">
                                                                    <img src={product.product_image} className="compareImage" alt={product.product_name || 'Compare product'}/>
                                                                </div>
                                                                <div className="ps-compare__product-title">{product.product_name || 'Product'}</div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>

                                                {compareRows.map((compareItemSub, rowIndex)=>{
                                                    if(compareItemSub[0] === 'ProductOverview'){
                                                        return null;
                                                    }

                                                    const rowValues = Array.isArray(compareItemSub[1]) ? compareItemSub[1] : [];

                                                    return(
                                                        <div className="ps-compare__row" key={`${compareItemSub[0]}-${rowIndex}`}>
                                                            <div className="ps-compare__label-cell">
                                                                <span>{compareItemSub[0]}</span>
                                                            </div>
                                                            {rowValues.map((value, valueIndex)=>{
                                                                return(
                                                                    <div className="ps-compare__value-cell" key={`${compareItemSub[0]}-${valueIndex}`}>
                                                                        <span>{value || '-'}</span>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )
                                    })}
                                </div>
                            }
                        </div>
                    </section>

                </div>

            </div>
    
        );
    }
}

export default Compare;
